import React from "react";
import Popper from '@material-ui/core/Popper';
import  { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import appConstants from "../../../appConstants";
import Tooltip from "../../common/StyledToolTip";

const styles = theme =>({
    lockStatusIconStyles: {
        padding: "6px 0px",
        cursor: "pointer",
        display: 'inline-block',
        '&:not(:last-child)':{
            '&>$popperIcon': {
                borderRight: `1px solid ${theme.AppBGColor}`,
            },
        },
        '&:hover>$popperIcon': {
            color: theme.HeaderSelectedText,
        },
        '&:hover>$lockStateText': {
            color: theme.HeaderSelectedText,
        },
    },
    paper: {
        backgroundColor: theme.ModalBGColor,
    },
    lockStateText: {
        color: theme.TextColor,
        fontSize: theme.textFontSize,
        padding: '0px 12px',
    },
    selectedLockState: {
        '&>$popperIcon': {
            color: theme.HeaderSelectedText,
          },
        '&>$lockStateText': {
            color: theme.HeaderSelectedText,
        },
    },
    root: {
        height: '100%',
        width: '100%',
        display: 'table',
    },
    icon: {
        fontSize: '16px',
        textAlign: 'center',
        display: 'table-cell',
        verticalAlign: 'middle',
        color: theme.iconColor,
        cursor: 'pointer',
    },
    popperIcon: {
        fontSize: '16px',
        textAlign: 'center',
        display: 'block',
        color: theme.iconColor,
        cursor: 'pointer',
    },
    iconLock: {
        color: theme.HeaderSelectedText,
    },
    popper: {
        zIndex: 1,
        '&[x-placement*="right"] $arrow': {
          left: 0,
          marginLeft: '-0.9em',
          height: '3em',
          width: '1em',
          '&::before': {
            borderWidth: '1em 1em 1em 0',
            borderColor: `transparent ${theme.ModalBGColor} transparent transparent`,
          },
        },
      },
      arrow: {
        position: 'absolute',
        fontSize: 7,
        width: '3em',
        height: '3em',
        '&::before': {
          content: '""',
          margin: 'auto',
          display: 'block',
          width: 0,
          height: 0,
          borderStyle: 'solid',
        },
      },
})


class LockStatusRenderer extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            lockState: Object.values(appConstants.routeLockStates).find(
                routeLockState => routeLockState.value === props.value
            ),
            anchorEl: null,
            open: false,
            arrowRef: null,
          };
          this.portalContainer = document.body; // default value;
          // portalContainer  will used to specify the dom node at which the portalled element should render
          // in case of grid cell editing we need it at column container so that it works well with scrolling
          if(this.props.eGridCell && this.props.eGridCell.parentElement && this.props.eGridCell.parentElement.parentElement){
            this.portalContainer = this.props.eGridCell.parentElement.parentElement
          }
    }

    handleClick = event => {
        const { currentTarget } = event;
        this.setState(state => ({
            anchorEl: currentTarget,
            open: !state.open,
        }));
    };

    handleArrowRef = node => {
        this.setState({
          arrowRef: node,
        });
      };

    handleClose = event => {
        this.setState({ open: false});
    };


    onLockStatusChanged = (event, lockStatus) => {
        const { field } = this.props.colDef || {};
        this.props.node && this.props.node.setDataValue && this.props.node.setDataValue(field, lockStatus);
        event.stopPropagation();
    }

    render(){
        const { classes } = this.props;
        const { anchorEl, open, arrowRef, lockState } = this.state;
        const id = open ? 'simple-popper' : null;

        if(this.props.data && this.props.data.routeName === "UNRTD"){
            return null;
        }else{
            return(lockState ?
                (<div className={classes.root}>
                    <Tooltip title={lockState.toolTipInfo} enterDelay={500}>
                        <i className={`${lockState.icon} ${classes.icon} ${lockState.text === "Unlock" ? '' : classes.iconLock}`}
                            onClick={this.handleClick}/>
                    </Tooltip>
                    <Popper
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        placement={"right"}
                        className={classes.popper}
                        modifiers={{
                            flip: {
                            enabled: true,
                            },
                            arrow: {
                            enabled: true,
                            element: arrowRef,
                            },
                            preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent',
                            },
                        }}
                        container={this.portalContainer}
                        >
                        <ClickAwayListener onClickAway={this.handleClose} onScroll={this.handleClose}>
                            <Paper className={classes.paper}>
                                <React.Fragment>
                                    <span className={classes.arrow} ref={this.handleArrowRef} />
                                    {Object.values(appConstants.routeLockStates).map((routeLockState) => {
                                        return (
                                        <div className={`${classes.lockStatusIconStyles} ${routeLockState.value === lockState.value ? classes.selectedLockState : ''}`}
                                            onClick={event => this.onLockStatusChanged(event, routeLockState.value)}
                                            key={routeLockState.text}
                                            >
                                            <i className = {`${routeLockState.icon} ${classes.popperIcon}` }/>
                                            <div className={classes.lockStateText}>{routeLockState.text}</div>
                                        </div>)
                                        })}
                                </React.Fragment>
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                </div>) :
                ''
            )
        }
    }
}

export default withStyles(styles)(LockStatusRenderer);